import {
  MULTI_PURPOSE_CENTRE_ADDITIONAL_DELETE_ACTION_TYPE,
  MULTI_PURPOSE_CENTRE_ADD_ACTION_TYPE,
  MULTI_PURPOSE_CENTRE_DELETE_ACTION_TYPE,
  MULTI_PURPOSE_CENTRE_DETAIL_ACTION_TYPE,
  MULTI_PURPOSE_CENTRE_LIST_ACTION_TYPE,
  MULTI_PURPOSE_CENTRE_PRICING_DELETE_ACTION_TYPE,
} from "../../utils/constants";
const initialState = [];
function multiPurposeCentreReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case MULTI_PURPOSE_CENTRE_LIST_ACTION_TYPE:
      return [...state, payload];
    case MULTI_PURPOSE_CENTRE_ADD_ACTION_TYPE:
      return [...state, payload];
    case MULTI_PURPOSE_CENTRE_DETAIL_ACTION_TYPE:
      return [...state, payload];
    case MULTI_PURPOSE_CENTRE_DELETE_ACTION_TYPE:
      return [...state, payload];
    default:
      return state;
  }
}
export default multiPurposeCentreReducer;
